const handleScrolledState = () => {
  const menu = document.getElementById("main-navigation");

  if (window.scrollY > 16 && !menu.classList.contains("scrolled")) {
    menu.classList.add("scrolled");
  }
  if (window.scrollY <= 16) {
    menu.classList.remove("scrolled");
  }
};

const handleSubMenuClose = (menuItem) => {
  menuItem.classList.add("freeze");
  menuItem.classList.remove("open");
  menuItem.classList.remove("opening");

  const toggles = menuItem.querySelectorAll(".sub-menu-toggle");

  toggles.forEach((toggle) => {
    toggle.setAttribute("aria-expanded", "false");
  });

  setTimeout(() => {
    menuItem.classList.remove("freeze");
  }, 750);
};

const handleSubMenuOpen = (menuItem) => {
  menuItem.classList.add("opening");
  menuItem.classList.add("open");

  const toggles = menuItem.querySelectorAll(".sub-menu-toggle");

  toggles.forEach((toggle) => {
    toggle.setAttribute("aria-expanded", "true");
  });
};

const handleSubMenuToggle = (event, toggle) => {
  event.stopPropagation();
  
  const menuItem = toggle.closest(".main-navigation__item");

  if (menuItem.classList.contains("open")) {
    // the toggled item is open, so close it...
    handleSubMenuClose(menuItem);
  } else {
    // the toggled item is closed, so we'll open...
    // but first, we'll close the others...
    const openItems = document.querySelectorAll(".open");

    openItems.forEach((openItem) => {
      handleSubMenuClose(openItem);
    });

    handleSubMenuOpen(menuItem);
  }
};

const menuToggleInit = () => {
  const menuToggle = document.getElementById("menu-toggle");

  menuToggle.onclick = () => {
    //toggle menu
    document.body.classList.toggle("menu-is-open");
    // reset submenus
    const openItems = document.querySelectorAll(".open");
    openItems.forEach((openItem) => {
      handleSubMenuClose(openItem);
    });

    // close search...
    document.body.classList.remove("search-is-open");
  };
};

const subMenuToggleInit = () => {
  const subMenuToggles = document.querySelectorAll(".sub-menu-toggle");

  subMenuToggles.forEach((toggle) => {
    toggle.addEventListener("click", (event) => handleSubMenuToggle(event, toggle));
  });
};

const searchToggleInit = () => {
  const searchToggle = document.getElementById("search-toggle");

  searchToggle.onclick = () => {
    //close menu if open menu
    document.body.classList.remove("menu-is-open");
    // reset submenus
    const openItems = document.querySelectorAll(".open");
    openItems.forEach((openItem) => {
      handleSubMenuClose(openItem);
    });
    document.body.classList.toggle("search-is-open");
  };
};

// close menu if clicking outside
const handleClickOutside = (event) => {
  const openSubNavItem = document.querySelector(".main-navigation__item.open");
  
  // If no open menu item, do nothing
  if (!openSubNavItem) return;

  // Check if the click is inside the dropdown or its children
  const dropdown = openSubNavItem.querySelector(".main-navigation__dropdown");
  const isInsideDropdown = dropdown && dropdown.contains(event.target);
  
  // If click is outside the dropdown, close the menu
  if (!isInsideDropdown) {
    handleSubMenuClose(openSubNavItem);
  }
};

export default function () {
  handleScrolledState();
  menuToggleInit();
  subMenuToggleInit();
  searchToggleInit();

  document.addEventListener("click", function (event) {
    const searchBox = document.getElementById("main-navigation-search");
    const searchToggle = document.getElementById("search-toggle");

    handleClickOutside(event)

    if (
      !searchBox.contains(event.target) &&
      !searchToggle.contains(event.target)
    ) {
      document.body.classList.remove("search-is-open");
    }
  });

  document.addEventListener("scroll", () => {
    handleScrolledState();
  });
}
